import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-skeleton-flux',
  templateUrl: './skeleton-flux.component.html',
  styleUrls: ['./skeleton-flux.component.scss']
})
export class SkeletonFluxComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
